/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
//Constant
import { LangStyle } from 'constants/index';

/* Services */

/**
 * Returns the Quotes.
 * @param {object} pageDataDetail - Style
 * @param {string} region - Current User country?.
 * @param {string} language - Current User Language.
 * @returns {ReactElement}  Quotes V2 component.
 */
export default function QuotesV2({ pageDataDetail, region, language }) {
  const router = useRouter();
  return (
    <Box maxWidth="1300px" margin="0 auto">
      <Box as="section" width="100%" textAlign="center">
        <Box pos="relative">
          <Flex
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            w="100%"
            paddingTop={'10px'}
            paddingBottom={'15px'}
          >
            <Box
              pos="relative"
              w={{ base: '78%', sm: '79%', md: '76%', lg: '76%' }}
              m={'auto'}
              fontSize={{ base: '16px', sm: '16px', md: '20px', lg: '20px' }}
              lineHeight="28px"
              textAlign="center"
              color="#28231E"
              fontStyle={'italic'}
              fontWeight={'400'}
              fontFamily={
                LangStyle[language]?.headingFont
                  ? LangStyle[language].headingFont
                  : 'FedraSansStd-book'
              }
              p="20px"
              dir={
                LangStyle[language]?.direction
                  ? LangStyle[language].direction
                  : 'none'
              }
            >
              "{pageDataDetail?.quote}"
            </Box>
            <Box
              w={{ base: '85px', sm: '85px', md: '108px', lg: '108px' }}
              h={{ base: '42px', sm: '42px', md: '51px', lg: '51px' }}
              mb={{ base: '20px', sm: '16px', md: '16px', lg: '16px' }}
            >
              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1663654954-signature_name.png`}
                alt="sadhguru signature"
                title="sadhguru signature"
              />
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}
